import { render } from "./CacheSettings.vue?vue&type=template&id=f1c467d8&scoped=true"
import script from "./CacheSettings.vue?vue&type=script&lang=js"
export * from "./CacheSettings.vue?vue&type=script&lang=js"

import "./CacheSettings.vue?vue&type=style&index=0&id=f1c467d8&scoped=true&lang=css"

import exportComponent from "/home/utogplukkno/www.utogplukk.no/releases/78563473/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1c467d8"]])

export default __exports__